import { Link } from 'react-router-dom'
import { Pencil } from 'lucide-react'
import { icsUrl, googleCalendarUrl, linkedInShareUrl } from '../lib/api.js'
import { BTN_GHOST_BRAND, BTN_PRIMARY } from '../lib/ui.js'

export function canEditEvent(event, me) {
  if (!me || !event) return false
  if (me.role === 'ADMIN') return true
  return (event.speakers || []).some((s) => s.userId === me.userId)
}

export default function EventActions({ event, me }) {
  const showEdit = canEditEvent(event, me)
  return (
    <section className="mt-6 flex flex-wrap items-center gap-2">
      <a
        href={googleCalendarUrl(event)}
        target="_blank"
        rel="noopener noreferrer"
        className={BTN_PRIMARY}
      >
        Add to Google Calendar
      </a>
      <a
        href={icsUrl(event.id)}
        download
        className={BTN_GHOST_BRAND}
      >
        Download .ics
      </a>
      {event.registrationUrl ? (
        <a
          href={event.registrationUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex min-h-[44px] items-center rounded-full px-3 py-2 text-sm font-medium text-slate-700 hover:bg-slate-100"
        >
          Register ↗
        </a>
      ) : null}
      <a
        href={linkedInShareUrl(event)}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Share on LinkedIn"
        title="Share on LinkedIn"
        className="inline-flex min-h-[44px] min-w-[44px] items-center justify-center gap-1.5 rounded-full px-3 py-2 text-sm font-medium text-slate-700 hover:bg-slate-100"
      >
        <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
        </svg>
        <span className="hidden sm:inline">Share</span>
      </a>
      {showEdit ? (
        <Link
          to={`/admin/events/${event.id}`}
          className="inline-flex min-h-[44px] items-center gap-1.5 rounded-full px-3 py-2 text-sm font-medium text-slate-700 hover:bg-slate-100"
        >
          <Pencil className="h-4 w-4" aria-hidden="true" />
          <span>Edit</span>
        </Link>
      ) : null}
      <Link
        to="/contract"
        className="inline-flex min-h-[44px] items-center rounded-full px-3 py-2 text-sm font-medium text-slate-700 hover:bg-slate-100"
        title="View the ODCS data contract for /api/v1/events"
      >
        View data contract
      </Link>
    </section>
  )
}
